import * as React from "react";
import { Button } from "@/components/ui/button";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useMfaChallengeContext } from "../context";

export const PromptSetup: React.FC = () => {
  const { onSuccess, onOpenChange } = useMfaChallengeContext();

  const handlePromptAction = (goToSettings: boolean) => {
    if (goToSettings) {
      window.dispatchEvent(new CustomEvent("open-global-user-settings", { detail: { tab: "security" } }));
      toast.success("Opening security settings...");
    } else {
      onSuccess();
    }
    onOpenChange(false);
  };

  return (
    <div className="space-y-6 pt-4 animate-in fade-in duration-200">
      <div className="text-center space-y-4">
        <div className="h-16 w-16 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mx-auto shadow-inner">
          <ShieldCheck className="h-8 w-8" />
        </div>
        <div className="space-y-2">
          <h3 className="text-xl font-bold text-slate-800">Secure Your Account</h3>
          <p className="text-sm text-slate-500 leading-relaxed">
            Want to save yourself some time? Add a <b>Phone Number</b> or <b>Passkey</b> as another method for securing
            your account
          </p>
        </div>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-3">
        <div className="flex items-center gap-3 text-sm text-slate-600 font-medium">
          <div className="h-2 w-2 rounded-full bg-blue-500" />
          Faster than waiting for emails
        </div>
        <div className="flex items-center gap-3 text-sm text-slate-600 font-medium">
          <div className="h-2 w-2 rounded-full bg-blue-500" />
          Stronger protection against hacking
        </div>
      </div>

      <div className="flex flex-col gap-2 pt-2">
        <Button className="w-full h-12 font-bold gap-2" onClick={() => handlePromptAction(true)}>
          <span>Set Up Now</span>
          <ArrowRight className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          className="w-full text-slate-400 hover:text-slate-600 font-medium"
          onClick={() => handlePromptAction(false)}
        >
          Remind me later
        </Button>
      </div>
    </div>
  );
};
